/* DD v6: (1) left / right arrow buttons for the homepage product rows (desktop only; hidden on phones by CSS).
           (2) closes the quick-add option list after a choice or a click elsewhere.
           (3) coffee Grind dropdown on product pages (7 grinds, saved as an order note). */
(function () {
  function setup(grid) {
    var sec = grid.parentElement;
    if (!sec || sec.querySelector('.dd-arrow')) return;
    sec.classList.add('dd-has-arrows');

    function make(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dd-arrow dd-arrow-' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous products' : 'Next products');
      b.innerHTML = dir === 'prev' ? '&#8592;' : '&#8594;';
      b.addEventListener('click', function () {
        grid.scrollBy({ left: (dir === 'prev' ? -1 : 1) * grid.clientWidth, behavior: 'smooth' });
      });
      sec.appendChild(b);
      return b;
    }

    var prev = make('prev');
    var next = make('next');

    function update() {
      var max = grid.scrollWidth - grid.clientWidth - 2;
      var overflow = max > 0;
      prev.classList.toggle('dd-arrow-off', !overflow || grid.scrollLeft <= 2);
      next.classList.toggle('dd-arrow-off', !overflow || grid.scrollLeft >= max);
    }

    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    setTimeout(update, 600);
  }

  /* coffee grind: which real variant each of the 7 grinds uses behind the scenes */
  var GRIND_MAP = {
    'Whole Bean': 'Whole Bean',
    'Espresso': 'Espresso Grind',
    'Moka Pot': 'Espresso Grind',
    'Aeropress': 'Filter Grind',
    'Pour Over': 'Filter Grind',
    'Moccamaster': 'Filter Grind',
    'Cold Brew': 'Filter Grind'
  };

  function linkGrindToForm() {
    var form = document.querySelector('form[id^="product-form-"]:not([id*="installment"])');
    if (!form) return;
    document.querySelectorAll('.dd-grind-prop').forEach(function (i) { i.setAttribute('form', form.id); });
  }

  function init() {
    document
      .querySelectorAll('.t-index [id$="__row_double_supreme"] x-grid.cards, .t-index .dd-collection-row x-grid.cards')
      .forEach(setup);
    linkGrindToForm();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.dd-grind-select');
    if (!s) return;
    linkGrindToForm();
    var scope = s.closest('product-content') || document;
    var prop = scope.querySelector('.dd-grind-prop');
    if (prop) prop.value = s.value;
    var native = scope.querySelector('select[name="options[Grind]"]');
    var target = GRIND_MAP[s.value];
    if (!native || !target) return;
    var has = Array.prototype.some.call(native.options, function (o) { return o.value === target; });
    if (has && native.value !== target) {
      native.value = target;
      native.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* quick add: close the option list after choosing, or when clicking anywhere else */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest && e.target.closest('.dd-quick-opt');
    if (opt) {
      var d = opt.closest('details');
      if (d) setTimeout(function () { d.removeAttribute('open'); }, 0);
      return;
    }
    document.querySelectorAll('.dd-quick-multi[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
})();
